<template>
  <div
    :class="`tw-flex tw-flex-col tw-w-full tw-min-h-16 tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]
       `"
  >
    <div
      class="tw-flex tw-items-center tw-justify-between tw-pt-[23px] tw-pb-[25px] tw-px-[25px] tw-cursor-pointer"
      :class="` ${className ? className : className} ${
        isOpen ? 'tw-bg-[#F2F8FF]' : 'tw-bg-[#FFF]'
      }`"
      @click.stop="isOpen = !isOpen"
    >
      <div class="tw-flex tw-items-center tw-w-full tw-truncate tw-max-h-5">
        <span class="tw-text-[#211F58] tw-text-[13px] tw-font-medium">
          {{ title }}
        </span>
        <div class="tw-ml-[15px]">
          <IssuesNumberDots :severity="scanItems" :hidden="true" />
        </div>
      </div>
      <button class="tw-w-6 tw-h-full">
        <ArrowDownTableIcon
          :class="{
            'right-arrow-icon': true,
            'right-arrow-icon-show': isOpen,
          }"
        />
      </button>
    </div>

    <!-- Element to collapse -->
    <b-collapse :visible="isOpen">
      <div
        class="tw-py-[25px] tw-px-[25px]"
        :class="`${isOpen ? 'tw-bg-[#f2f8ff80]' : 'tw-bg-[#FFF]'}`"
      >
        <slot />
      </div>
    </b-collapse>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import ArrowDownTableIcon from "@/components/svgs/arrowDownTableIcon.vue";
import IssuesNumberDots from "@/components/scanning/issuesNumberDots.vue";

defineProps<{
  title: string;
  className?: string;
  scanItems?: {
    critical: number;
    high: number;
    medium: number;
    low: number;
  };
}>();

const isOpen = ref(false);
</script>

<style scoped lang="scss">
.text {
  font-family: Poppins, sans-serif;
}
.right-arrow-icon {
  transition: transform 0.3s;
  &-show {
    transform: rotate(-180deg);
  }
}
</style>
